import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { legalLinks, navigation } from '../../data/navigation';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="bg-aloe-900 text-cream" data-id="element-127" data-mp="akm60w7rvh5a">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 md:px-8" data-id="element-128" data-mp="5nce99wwutea">
        <div className="grid gap-14 lg:grid-cols-12" data-id="element-129" data-mp="5p6uwc15fzck">
          <div className="lg:col-span-5" data-id="element-130" data-mp="p16d4q6esyp">
            <p className="font-serif text-5xl leading-[1.05] md:text-6xl" data-id="element-131" data-mp="q2gn6zdbbfd">
              Le bien-être
              <br data-id="element-132" data-mp="3s0u88bizc9qd" />
              <span className="italic text-leaf" data-id="element-133" data-mp="3n3atzbma7wyf">au naturel.</span>
            </p>
            <p className="mt-6 max-w-sm text-cream/70" data-id="element-134" data-mp="3n17rvt7uuddc">
              Cosmétiques et compléments alimentaires à l’aloe vera bio, cultivée en Andalousie.
            </p>
            <div className="mt-8 flex flex-col gap-3 text-sm" data-id="element-135" data-mp="3e2cqcufr9rgd">
              <a href="tel:+33670439897" className="inline-flex items-center gap-3 text-cream/90 hover:text-leaf" data-id="element-136" data-mp="393j8kptfreae">
                <PhoneIcon className="h-4 w-4" data-id="element-137" data-mp="2kc1uiht1b7ua" /> 06 70 43 98 97
              </a>
              <a href="mailto:contact@aloe-sol.com" className="inline-flex items-center gap-3 text-cream/90 hover:text-leaf" data-id="element-138" data-mp="2p435m0egusiq">
                <MailIcon className="h-4 w-4" data-id="element-139" data-mp="2bdq1680s9vy5" /> contact@aloe-sol.com
              </a>
            </div>
          </div>

          <nav aria-label="Plan du site" className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-7" data-id="element-140" data-mp="2gbrjgqqdxr8k">
            {navigation.filter(item => item.children).map(item => <div key={item.label} data-id="element-141" data-mp="380ctfff66xfx">
                  <h2 className="text-xs font-semibold uppercase tracking-[0.14em] text-cream/50" data-id="element-142" data-mp="2u3pha5enc0pf">{item.label}</h2>
                  <ul className="mt-5 space-y-3" data-id="element-143" data-mp="2z0ppalv23dj6">
                    {item.children?.map(child => <li key={child.href} data-id="element-144" data-mp="1imzllg7umra2">
                        <Link to={child.href} className="text-cream/90 transition-colors duration-150 ease-out hover:text-leaf" data-id="element-145" data-mp="1nmu9dawbv0qw">
                          {child.label}
                        </Link>
                      </li>)}
                  </ul>
                </div>)}
            <div data-id="element-146" data-mp="usflg1f1vqjg">
              <h2 className="text-xs font-semibold uppercase tracking-[0.14em] text-cream/50" data-id="element-147" data-mp="urw8kz49bsca">Aloesol</h2>
              <ul className="mt-5 space-y-3" data-id="element-148" data-mp="pu4ebyg53u4x">
                {navigation.filter(item => !item.children).map(item => <li key={item.href} data-id="element-149" data-mp="fv53c97wjmer">
                      <Link to={item.href} className="text-cream/90 transition-colors duration-150 ease-out hover:text-leaf" data-id="element-150" data-mp="fu3pjwzi4ltc">
                        {item.label}
                      </Link>
                    </li>)}
              </ul>
            </div>
          </nav>
        </div>

        <div aria-hidden="true" className="mt-20 select-none font-serif text-[22vw] leading-[0.8] text-cream/[0.06] lg:text-[16rem]" data-id="element-151" data-mp="266jijggxpusq">
          aloesol
        </div>

        <div className="mt-6 flex flex-col gap-4 border-t border-cream/10 pt-6 text-sm text-cream/60 md:flex-row md:items-center md:justify-between" data-id="element-152" data-mp="28saeb60haq3g">
          <p data-id="element-153" data-mp="2dpj0risntgai">© {year} Aloesol. Tous droits réservés.</p>
          <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-154" data-mp="2ihagsze6w3me">
            {legalLinks.map(link => <li key={link.href} data-id="element-155" data-mp="2nhewwob6qwc3">
                <Link to={link.href} className="hover:text-cream" data-id="element-156" data-mp="2ngdm8ky30buw">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}